var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "#84849A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,30.3H8c-1,0-1.9-0.4-2.6-1.1c-0.7-0.7-1.1-1.6-1.1-2.6V5.3c0-1,0.4-1.9,1.1-2.6C6.1,2,7,1.7,8,1.7h10.7 c0.3,0,0.5,0.1,0.7,0.3l8,8c0.2,0.2,0.3,0.4,0.3,0.7v16c0,1-0.4,1.9-1.1,2.6S25,30.3,24,30.3z M8,3.7c-0.4,0-0.9,0.2-1.2,0.5 C6.5,4.5,6.3,4.9,6.3,5.3v21.3c0,0.4,0.2,0.9,0.5,1.2c0.3,0.3,0.7,0.5,1.2,0.5h16c0.4,0,0.9-0.2,1.2-0.5s0.5-0.7,0.5-1.2V11.1 l-7.4-7.4H8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.7,11.7h-8c-0.6,0-1-0.4-1-1v-8c0-0.6,0.4-1,1-1s1,0.4,1,1v7h7c0.6,0,1,0.4,1,1S27.2,11.7,26.7,11.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.3,18.3H10.7c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h10.7c0.6,0,1,0.4,1,1C22.3,17.9,21.9,18.3,21.3,18.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.3,23.7H10.7c-0.6,0-1-0.4-1-1s0.4-1,1-1h10.7c0.6,0,1,0.4,1,1S21.9,23.7,21.3,23.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3,13h-2.7c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.7c0.6,0,1,0.4,1,1S13.9,13,13.3,13z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneInfo);
export default __webpack_public_path__ + "static/media/gene_info.10649c16.svg";
export { ForwardRef as ReactComponent };